<script>
let src = './images/nac-apps.png'

</script>


<main>
	<h1>NAC apps</h1>
	<img {src} alt="making apps" height="250px">
</main>



<style>

	main {
	text-align: center;
	padding: 1em;
	//max-width: 400px;
	margin: 0 auto;
	}
	h1 {
		color: #00B7CE;
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 100;
	}
</style>
